import { FormattedMessage } from 'react-intl';
import Link from '@alltrails/denali/components/Link';
import type { LanguageRegionCode } from '@alltrails/types/LanguageRegionCode';
import type { TrailListSection, LocationData } from '../../utils/types';

type Props = {
  section: TrailListSection;
  idx: number;
  locationData?: LocationData;
  languageRegionCode: LanguageRegionCode;
};

const TrailRiverTitle = ({ section, idx, locationData, languageRegionCode }: Props) => {
  const locationCity = locationData?.city;

  if (idx === 0 && locationCity && section.river_section_type !== 'personalized_trail_list') {
    const shortRegionCode = languageRegionCode.split('-')[0];

    // Maxmind possible values: de, en, es, fr, ja, pt-BR, ru, zh-CN
    const cityName =
      locationCity.names[languageRegionCode === 'pt-BR' || languageRegionCode === 'pt-PT' ? 'pt-BR' : shortRegionCode] || locationCity.names.en;

    return (
      <FormattedMessage
        defaultMessage="Local favorites near <link>{cityName}</link>"
        values={{
          cityName,
          link: chunks => <Link href="/explore">{chunks}</Link>
        }}
      />
    );
  }

  return <>{section.title || ''}</>;
};

export default TrailRiverTitle;
